const PHONE_UA =
  /Android.*Mobile|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini|Mobile.*Firefox|Windows Phone/i;

/** Detecta si debemos servir la landing reducida (teléfonos). */
export function detectMobileLandingUa(ua: string): boolean {
  return PHONE_UA.test(ua);
}

/**
 * Lee la decisión tomada en index.html (`data-landing`) o recalcula por UA.
 * Override de preview: `?mobile=1` / `?mobile=0`.
 */
export function isMobileLanding(): boolean {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;

  try {
    const param = new URLSearchParams(window.location.search).get('mobile');
    if (param === '1' || param === 'true') return true;
    if (param === '0' || param === 'false') return false;
  } catch {
    /* ignore */
  }

  const flag = document.documentElement.dataset.landing;
  if (flag === 'mobile') return true;
  if (flag === 'desktop') return false;

  return detectMobileLandingUa(navigator.userAgent || '');
}
